var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIllGamesTablet = function SvgIllGamesTablet(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 744,
    height: 233,
    viewBox: "0 0 744 233",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 372,
    cy: 1612,
    r: 1592,
    fill: "#F6D703"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M522.275 42.3166L526.779 43.1495L547.891 43.2836L539.548 41.9707L522.275 42.3166Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M548.612 9.08496L542.309 24.3736C542.309 24.3736 547.624 26.2653 550.334 19.1362C551.661 12.4942 548.612 9.08496 548.612 9.08496Z",
    fill: "#ED1B98"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M518.676 2.11156C518.676 2.11156 533.64 3.00093 544.772 6.0502L537.925 22.5459L513.453 17.6191C513.453 17.6191 516.128 8.16068 518.683 2.10449L518.676 2.11156Z",
    fill: "#0066FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M504.052 16.5967L502.195 40.0168L526.745 42.8331L540.262 42.8331L540.262 21.347L527.387 20.0553L504.052 16.5967Z",
    fill: "#F6D638",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M508.327 17.2305L525.479 19.7715L523.87 42.4999L506.746 40.5376L508.327 17.2305Z",
    fill: "#ED1B98"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M536.655 20.9862L536.323 42.8323L529.857 42.8323L530.839 20.4004L536.655 20.9862Z",
    fill: "#ED1B98"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M519.876 26.3539C520.156 24.1535 519.045 22.1992 517.394 21.9889C515.742 21.7785 514.177 23.3917 513.896 25.5921C513.616 27.7924 514.727 29.7467 516.378 29.9571C518.03 30.1674 519.596 28.5542 519.876 26.3539Z",
    fill: "#F6D638"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M516.701 22.9697C516.701 22.9697 514.873 23.5203 514.852 25.9696C514.831 28.4189 515.847 28.8847 516.489 29.0047C516.489 29.0047 517.541 29.4 518.169 28.1154",
    stroke: "black",
    strokeWidth: 0.4,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M544.773 6.04981L548.612 9.08496L542.309 24.3736L537.926 22.5526L544.773 6.04981Z",
    fill: "#F6D638"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M531.158 7.8144C531.158 7.8144 530.177 0.381807 536.395 0.614738C542.614 0.847669 540.856 8.99316 537.546 10.179C537.546 10.179 535.075 11.0684 534.433 12.84L531.356 11.8024C531.356 11.8024 531.56 9.40256 531.151 7.8144L531.158 7.8144Z",
    fill: "#F6D638"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M527.146 20.0187L529.857 14.4707L533.443 15.9389L531.424 20.3998L527.146 20.0187Z",
    fill: "#F6D638"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M527.846 13.9481L535.731 17.1879C535.801 17.2162 535.872 17.2373 535.949 17.2514C536.387 17.315 537.827 17.4138 538.363 15.9315C539.006 14.1739 537.036 13.581 537.036 13.581L529.145 10.5106C528.898 10.4118 528.616 10.4188 528.376 10.5318C528.002 10.7153 527.479 11.1106 527.225 11.9293C526.936 12.854 527.253 13.4257 527.479 13.694C527.578 13.8069 527.698 13.8916 527.832 13.941L527.846 13.9481Z",
    fill: "#F6D638"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M531.391 11.3864L534.539 12.6146L531.405 10.9629",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M527.682 13.8643L535.827 17.2876",
    stroke: "black",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M529.061 16.1221L529.668 14.6963L532.067 15.9386L529.618 15.628L531.312 16.4538",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M506.62 17.4983L506.133 5.80238C506.126 5.56945 506.345 5.39298 506.571 5.45651C507.425 5.67532 509.373 6.52234 511.512 9.86807L518.987 4.96241C519.227 4.80007 519.558 4.92713 519.636 5.20241L521.838 13.0162L526.716 9.80454C526.913 9.67043 527.174 9.84689 527.132 10.0798L525.262 20.0958L506.613 17.4983L506.62 17.4983Z",
    fill: "#F6D638"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M506.133 9.08496L511.102 13.5247L517.356 9.93198L521.436 16.5952L526.334 14.3647",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M511.519 25.4057C512.735 25.4057 513.721 24.4387 513.721 23.2458C513.721 22.053 512.735 21.0859 511.519 21.0859C510.302 21.0859 509.316 22.053 509.316 23.2458C509.316 24.4387 510.302 25.4057 511.519 25.4057Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M516.369 20.4004C517.643 20.4004 518.677 19.4018 518.677 18.1699C518.677 16.9381 517.643 15.9395 516.369 15.9395C515.094 15.9395 514.061 16.9381 514.061 18.1699C514.061 19.4018 515.094 20.4004 516.369 20.4004Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M513.721 21.1974C514.758 21.1974 515.599 20.2746 515.599 19.1363C515.599 17.998 514.758 17.0752 513.721 17.0752C512.684 17.0752 511.844 17.998 511.844 19.1363C511.844 20.2746 512.684 21.1974 513.721 21.1974Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M510.968 30.4803C512.173 30.4803 513.149 29.4691 513.149 28.2216C513.149 26.9742 512.173 25.9629 510.968 25.9629C509.764 25.9629 508.787 26.9742 508.787 28.2216C508.787 29.4691 509.764 30.4803 510.968 30.4803Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M510.029 35.1815C511.261 35.1815 512.26 34.2397 512.26 33.078C512.26 31.9163 511.261 30.9746 510.029 30.9746C508.797 30.9746 507.799 31.9163 507.799 33.078C507.799 34.2397 508.797 35.1815 510.029 35.1815Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M509.035 39.5708C510.177 39.5708 511.103 38.6449 511.103 37.5027C511.103 36.3605 510.177 35.4346 509.035 35.4346C507.893 35.4346 506.967 36.3605 506.967 37.5027C506.967 38.6449 507.893 39.5708 509.035 39.5708Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M506.121 42.8329C507.193 42.8329 508.062 41.8975 508.062 40.7436C508.062 39.5897 507.193 38.6543 506.121 38.6543C505.049 38.6543 504.18 39.5897 504.18 40.7436C504.18 41.8975 505.049 42.8329 506.121 42.8329Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M499.336 41.0958C500.354 41.0958 501.179 40.2078 501.179 39.1123C501.179 38.0169 500.354 37.1289 499.336 37.1289C498.319 37.1289 497.494 38.0169 497.494 39.1123C497.494 40.2078 498.319 41.0958 499.336 41.0958Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M502.353 44.5683C503.476 44.5683 504.386 43.5981 504.386 42.4013C504.386 41.2046 503.476 40.2344 502.353 40.2344C501.23 40.2344 500.32 41.2046 500.32 42.4013C500.32 43.5981 501.23 44.5683 502.353 44.5683Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M502.633 38.7455C503.6 38.7455 504.384 37.9176 504.384 36.8962C504.384 35.8748 503.6 35.0469 502.633 35.0469C501.667 35.0469 500.883 35.8748 500.883 36.8962C500.883 37.9176 501.667 38.7455 502.633 38.7455Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M173.385 54.9816L190.335 54.9816L178.665 53.6768L173.385 54.9816Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M174.489 54.9811C181.939 54.9811 187.979 48.9412 187.979 41.4906C187.979 34.0399 181.939 28 174.489 28C167.038 28 160.998 34.0399 160.998 41.4906C160.998 48.9412 167.038 54.9811 174.489 54.9811Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M179.722 36.5791C165 36.6661 160.998 41.4842 160.998 41.4842C161.634 53.623 172.689 54.8543 172.689 54.8543C175.118 43.9936 181.274 39.9919 181.274 39.9919L179.722 36.5791V36.5791Z",
    fill: "#ED1B98"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M168.922 29.1983C168.922 29.1983 175.46 30.8311 179.722 36.5793C179.722 36.3518 183.778 36.7399 183.778 36.7399C183.778 36.7399 183.068 32.2498 180.98 29.6534C180.98 29.6534 175.246 26.3343 168.922 29.1916L168.922 29.1983Z",
    fill: "#ED1B98"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M184.084 50.9739C184.084 50.9739 184.947 42.7564 181.273 39.9994L182.424 36.5331C182.424 36.5331 186.232 36.1784 187.744 38.9756C187.744 38.9756 189.551 45.7543 184.084 50.9806L184.084 50.9739Z",
    fill: "#ED1B98"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M182.671 40.0349C183.796 39.6354 184.325 38.2331 183.853 36.9028C183.38 35.5724 182.086 34.8177 180.961 35.2172C179.836 35.6166 179.307 37.0189 179.779 38.3493C180.252 39.6797 181.547 40.4344 182.671 40.0349Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3413 68.9901C48.3413 68.9901 48.2011 67.8184 45.9263 67.0939C43.6515 66.3693 39.311 64.4009 41.3554 61.7407C41.3554 61.7407 42.7477 60.5401 44.0162 62.7665C45.2848 64.9929 46.126 65.6794 45.9541 65.1402C45.7821 64.6009 44.9385 63.2857 43.9503 60.8073C42.9622 58.3289 40.8821 54.2891 43.5366 52.389C46.1911 50.489 47.027 54.6638 46.562 56.0001C46.097 57.3365 45.5605 59.2473 45.8055 60.5482C46.0505 61.8492 46.3796 64.2124 46.3438 63.3681C46.308 62.5238 46.1006 62.0949 46.3768 60.3661C46.5469 59.2581 47.1363 58.5115 48.4411 58.7886C49.7458 59.0657 49.6225 62.2945 48.4068 64.1602C47.1912 66.0258 49.6277 67.2575 49.7149 67.753C49.8022 68.2485 50.6349 68.7752 48.3328 68.9857L48.3413 68.9901Z",
    fill: "#32BF5E"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M733.876 63.149C733.876 63.149 734.289 62.3065 734.575 62.3254C734.861 62.3443 735.747 62.7765 737.089 62.5226C738.431 62.2688 739.462 61.4258 738.742 60.5522C738.022 59.6785 736.036 60.1171 735.303 61.1395C735.303 61.1395 735.557 60.1996 735.911 59.8444C736.265 59.4893 737.91 59.3079 739.078 58.7084C740.245 58.1088 741.018 57.3165 740.638 56.1336C740.258 54.9507 738.643 55.9749 737.957 57.3172C737.671 57.7301 737.185 58.7144 736.617 58.6551C737.011 58.3403 737.538 56.2268 739.575 54.4734C741.613 52.7201 742.462 50.8083 741.183 50.2828C739.905 49.7572 739.37 51.1928 739.08 52.5666C738.79 53.9404 738.682 54.2456 737.831 55.3557C736.98 56.4657 736.107 57.762 736.03 57.9421C735.952 58.1222 735.93 57.5422 736.616 56.3209C737.529 54.6901 738.034 53.5125 736.688 53.2803C735.341 53.0481 734.451 55.1615 734.838 57.1482C735.214 59.0786 734.903 59.0374 734.399 60.158C734.399 60.158 734.252 60.3255 734.426 59.115C734.599 57.9046 734.176 56.1383 733.324 56.124C732.471 56.1097 731.881 58.4262 732.666 59.9674C733.451 61.5086 733.532 61.7624 733.401 62.0001C733.27 62.2379 732.949 62.7453 732.949 62.7453C732.949 62.7453 733.31 63.4074 733.878 63.1442L733.876 63.149Z",
    fill: "#32BF5E"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M465.534 102.516C465.534 102.516 467.546 102.89 468.596 101.059C469.645 99.228 470.464 99.5096 470.823 97.1155C471.181 94.7214 470.572 94.294 469.645 94.4931C468.719 94.6922 467.766 96.2559 467.766 99.5193C467.659 100.131 467.485 100.525 467.495 100.481C467.582 100.112 468.058 97.572 466.712 95.343C465.688 93.6481 464.07 92.1378 462.806 92.8371C461.541 93.5364 462.734 95.3575 464.413 97.5817C464.413 97.5817 467.142 100.554 466.614 101.117C466.087 101.68 465.544 102.516 465.544 102.516L465.534 102.516Z",
    fill: "#32BF5E"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3951 223.91C14.3951 223.91 17.3062 222.597 16.8996 219.199C16.4931 215.802 17.8012 215.44 15.9814 211.911C14.1616 208.382 12.9816 208.359 11.9938 209.461C11.0059 210.563 11.2822 213.515 14.3833 217.885C14.8281 218.802 14.9808 219.485 14.9523 219.418C14.7122 218.845 12.9034 215.015 9.07496 213.243C6.1638 211.897 2.67362 211.332 1.73185 213.409C0.790071 215.485 4.03583 216.848 8.28241 218.313C8.28241 218.313 14.5728 219.834 14.4383 221.063C14.3037 222.293 14.4082 223.901 14.4082 223.901L14.3951 223.91Z",
    fill: "#32BF5E"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M651.705 78.0089L649.392 81.0559C649.309 81.2059 649.307 81.3767 649.383 81.5229L650.827 84.2654C651.019 84.6343 650.683 85.0665 650.255 85.0033L647.08 84.4963C646.907 84.4671 646.737 84.5218 646.61 84.6436L644.065 87.4774C643.753 87.7756 643.228 87.6134 643.179 87.2011L643.016 83.529C642.997 83.3667 642.891 83.2252 642.739 83.1488L638.795 81.4984C638.407 81.3182 638.419 80.7804 638.816 80.5935L642.825 79.4974C642.981 79.4257 643.09 79.2804 643.118 79.1143L643.659 76.0402C643.729 75.6251 644.264 75.4589 644.562 75.7532L646.768 77.9654C646.89 78.0852 647.057 78.1399 647.228 78.1078L651.168 77.2721C651.598 77.2031 651.918 77.6277 651.702 78.0023L651.705 78.0089Z",
    fill: "#2FCDF2"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3198 76.0585C99.6064 76.0585 99.8388 75.8261 99.8388 75.5395C99.8388 75.2529 99.6064 75.0205 99.3198 75.0205C99.0331 75.0205 98.8008 75.2529 98.8008 75.5395C98.8008 75.8261 99.0331 76.0585 99.3198 76.0585Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M101.216 77.3823C101.397 77.3823 101.543 77.2357 101.543 77.0549C101.543 76.8741 101.397 76.7275 101.216 76.7275C101.035 76.7275 100.889 76.8741 100.889 77.0549C100.889 77.2357 101.035 77.3823 101.216 77.3823Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4142 137.237C97.7669 137.237 98.0529 136.951 98.0529 136.598C98.0529 136.245 97.7669 135.959 97.4142 135.959C97.0614 135.959 96.7754 136.245 96.7754 136.598C96.7754 136.951 97.0614 137.237 97.4142 137.237Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7804 133.472C96.0097 133.472 96.1956 133.286 96.1956 133.057C96.1956 132.827 96.0097 132.642 95.7804 132.642C95.5511 132.642 95.3652 132.827 95.3652 133.057C95.3652 133.286 95.5511 133.472 95.7804 133.472Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6493 139.846C55.0727 139.846 55.4158 139.502 55.4158 139.079C55.4158 138.656 55.0727 138.313 54.6493 138.313C54.226 138.313 53.8828 138.656 53.8828 139.079C53.8828 139.502 54.226 139.846 54.6493 139.846Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7001 187.69C39.1234 187.69 39.4666 187.347 39.4666 186.924C39.4666 186.5 39.1234 186.157 38.7001 186.157C38.2768 186.157 37.9336 186.5 37.9336 186.924C37.9336 187.347 38.2768 187.69 38.7001 187.69Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M176.485 118.839C176.983 118.839 177.386 118.436 177.386 117.938C177.386 117.441 176.983 117.037 176.485 117.037C175.987 117.037 175.584 117.441 175.584 117.938C175.584 118.436 175.987 118.839 176.485 118.839Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M178.896 114.559C179.284 114.559 179.599 114.244 179.599 113.856C179.599 113.468 179.284 113.153 178.896 113.153C178.508 113.153 178.193 113.468 178.193 113.856C178.193 114.244 178.508 114.559 178.896 114.559Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M217.728 34.3633C218.116 34.3633 218.431 34.0487 218.431 33.6607C218.431 33.2726 218.116 32.958 217.728 32.958C217.34 32.958 217.025 33.2726 217.025 33.6607C217.025 34.0487 217.34 34.3633 217.728 34.3633Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M219.353 37.1132C219.64 37.1132 219.872 36.8808 219.872 36.5942C219.872 36.3076 219.64 36.0752 219.353 36.0752C219.066 36.0752 218.834 36.3076 218.834 36.5942C218.834 36.8808 219.066 37.1132 219.353 37.1132Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M233.66 34.2261C233.868 34.2261 234.036 34.0581 234.036 33.8509C234.036 33.6436 233.868 33.4756 233.66 33.4756C233.453 33.4756 233.285 33.6436 233.285 33.8509C233.285 34.0581 233.453 34.2261 233.66 34.2261Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M376.032 135.921C376.239 135.921 376.407 135.753 376.407 135.546C376.407 135.339 376.239 135.171 376.032 135.171C375.824 135.171 375.656 135.339 375.656 135.546C375.656 135.753 375.824 135.921 376.032 135.921Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M267.877 86.9595C268.084 86.9595 268.253 86.7915 268.253 86.5843C268.253 86.377 268.084 86.209 267.877 86.209C267.67 86.209 267.502 86.377 267.502 86.5843C267.502 86.7915 267.67 86.9595 267.877 86.9595Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M233.66 34.2261C233.868 34.2261 234.036 34.0581 234.036 33.8509C234.036 33.6436 233.868 33.4756 233.66 33.4756C233.453 33.4756 233.285 33.6436 233.285 33.8509C233.285 34.0581 233.453 34.2261 233.66 34.2261Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M292.358 33.0298C292.565 33.0298 292.733 32.8618 292.733 32.6546C292.733 32.4473 292.565 32.2793 292.358 32.2793C292.15 32.2793 291.982 32.4473 291.982 32.6546C291.982 32.8618 292.15 33.0298 292.358 33.0298Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M470.098 62.8689C470.548 62.8689 470.912 62.5048 470.912 62.0556C470.912 61.6064 470.548 61.2422 470.098 61.2422C469.649 61.2422 469.285 61.6064 469.285 62.0556C469.285 62.5048 469.649 62.8689 470.098 62.8689Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M436.722 34.4271C437.101 34.4271 437.408 34.1196 437.408 33.7404C437.408 33.3611 437.101 33.0537 436.722 33.0537C436.343 33.0537 436.035 33.3611 436.035 33.7404C436.035 34.1196 436.343 34.4271 436.722 34.4271Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M512.372 121.853C512.821 121.853 513.185 121.489 513.185 121.04C513.185 120.591 512.821 120.227 512.372 120.227C511.923 120.227 511.559 120.591 511.559 121.04C511.559 121.489 511.923 121.853 512.372 121.853Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M569.667 68.5876C569.989 68.5876 570.25 68.3267 570.25 68.0048C570.25 67.6828 569.989 67.4219 569.667 67.4219C569.345 67.4219 569.084 67.6828 569.084 68.0048C569.084 68.3267 569.345 68.5876 569.667 68.5876Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M577.625 68.6114C577.876 68.6114 578.08 68.4077 578.08 68.1563C578.08 67.9049 577.876 67.7012 577.625 67.7012C577.374 67.7012 577.17 67.9049 577.17 68.1563C577.17 68.4077 577.374 68.6114 577.625 68.6114Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M590.773 138.368C591.025 138.368 591.229 138.164 591.229 137.913C591.229 137.662 591.025 137.458 590.773 137.458C590.522 137.458 590.318 137.662 590.318 137.913C590.318 138.164 590.522 138.368 590.773 138.368Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M622.634 107.23C623.057 107.23 623.4 106.887 623.4 106.464C623.4 106.04 623.057 105.697 622.634 105.697C622.21 105.697 621.867 106.04 621.867 106.464C621.867 106.887 622.21 107.23 622.634 107.23Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M694.399 178.998C694.823 178.998 695.166 178.655 695.166 178.231C695.166 177.808 694.823 177.465 694.399 177.465C693.976 177.465 693.633 177.808 693.633 178.231C693.633 178.655 693.976 178.998 694.399 178.998Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M686.425 226.844C686.848 226.844 687.191 226.5 687.191 226.077C687.191 225.654 686.848 225.311 686.425 225.311C686.001 225.311 685.658 225.654 685.658 226.077C685.658 226.5 686.001 226.844 686.425 226.844Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M606.683 195.946C607.106 195.946 607.449 195.603 607.449 195.18C607.449 194.756 607.106 194.413 606.683 194.413C606.259 194.413 605.916 194.756 605.916 195.18C605.916 195.603 606.259 195.946 606.683 195.946Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M140.091 130.53C139.604 132.659 138.408 134.414 135.968 134.749C135.466 134.82 135.027 134.733 134.58 135.012C133.911 135.434 133.576 136.662 132.706 136.567C131.319 136.415 128.081 135.044 127.619 134.079C127.268 133.353 128.058 132.851 127.898 132.006C127.834 131.647 127.755 131.447 127.563 131.144C126.869 130.028 126.59 128.752 126.877 127.5C127.547 124.566 131.056 122.867 134.708 123.696C138.36 124.526 140.776 127.588 140.099 130.522L140.091 130.53Z",
    fill: "#FCAEE0"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M128.91 132.022L132.881 134.415",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M129.324 127.405L129.898 132.62",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M130.441 132.947L134.524 125.65",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M131.127 133.219C131.358 133.003 131.302 133.059 137.331 128.458",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M131.564 133.625L136.445 132.62",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M520.583 73.3073C522.35 74.0265 523.58 75.1087 523.184 76.6748C523.103 76.9975 522.895 77.2529 523.023 77.5822C523.204 78.0729 524.219 78.5233 523.876 79.0475C523.338 79.8676 521.188 81.595 520.186 81.6891C519.44 81.7631 519.211 81.1783 518.405 81.1111C518.062 81.0842 517.86 81.0909 517.538 81.1447C516.335 81.3531 515.111 81.2724 514.069 80.8489C511.629 79.8541 511.112 77.3604 512.907 75.2768C514.708 73.1931 518.143 72.3058 520.583 73.3006L520.583 73.3073Z",
    fill: "#FCAEE0"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M518.707 80.4926L521.994 78.5098",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M514.682 79.3232L519.528 79.9954",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M519.978 79.7267L514.607 75.7744",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M520.413 79.3643C520.285 79.1761 520.319 79.2232 517.926 74.6055",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M520.906 79.1691L521.404 75.9629",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M244.41 99.9615C245.151 100.95 245.454 102.091 244.649 103.223C244.482 103.454 244.274 103.606 244.218 103.893C244.139 104.323 244.553 104.913 244.163 105.24C243.549 105.759 241.683 106.596 241.077 106.429C240.622 106.309 240.71 105.799 240.271 105.551C240.088 105.448 239.968 105.408 239.761 105.368C238.995 105.24 238.326 104.89 237.887 104.307C236.858 102.944 237.488 100.871 239.282 99.6664C241.077 98.4623 243.373 98.5899 244.402 99.9535L244.41 99.9615Z",
    fill: "#FCAEE0"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M240.676 105.144L243.291 104.379",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M238.691 103.184L241.331 104.954",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M241.69 104.849L240.016 101.165",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M242.074 104.666C242.074 104.491 242.074 104.22 242.417 100.025",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M242.432 104.634L243.899 102.242",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M721.599 226.113C722.341 227.102 722.644 228.242 721.838 229.374C721.671 229.606 721.464 229.757 721.408 230.044C721.328 230.475 721.743 231.065 721.352 231.392C720.738 231.91 718.872 232.747 718.266 232.58C717.812 232.46 717.899 231.95 717.461 231.703C717.277 231.599 717.158 231.559 716.95 231.519C716.185 231.392 715.515 231.041 715.076 230.459C714.048 229.095 714.678 227.022 716.472 225.818C718.266 224.614 720.563 224.741 721.591 226.105L721.599 226.113Z",
    fill: "#FCAEE0"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M717.867 231.296L720.483 230.53",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M715.881 229.334L718.52 231.104",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M718.88 231L717.205 227.316",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M719.264 230.819C719.264 230.643 719.264 230.372 719.607 226.178",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M719.621 230.786L721.088 228.394",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIllGamesTablet, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ill_games_tablet.320d5d01.svg";
export { ForwardRef as ReactComponent };